import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule as MatButtonModule } from '@angular/material/button';
import { MatDialogModule as MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { DialogConfirmComponent } from '@core/modules/dialogs/components/dialog-confirm/dialog-confirm.component';
import { DialogUploadComponent } from '@core/modules/dialogs/components/dialog-upload/dialog-upload.component';
import { SharedModule } from '@shared/shared.module';
import { DialogFilesDisplayComponent } from './components/dialog-files-display/dialog-files-display.component';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { DialogAcceptanceComponent } from './components/dialog-acceptance/dialog-acceptance.component';
import { DialogMultiOptionComponent } from './components/dialog-multi-option/dialog-multi-option.component';
import { DialogDocumentsSigningComponent } from './components/dialog-documents-signing/dialog-documents-signing.component';
import { DialogDeploymentNewsComponent } from './components/dialog-deployment-news/dialog-deployment-news.component';
import { DialogTextInputComponent } from './components/dialog-text-input/dialog-text-input.component';
import { QuillModule } from 'ngx-quill';

@NgModule({
    declarations: [
        DialogConfirmComponent,
        DialogUploadComponent,
        DialogFilesDisplayComponent,
        DialogAcceptanceComponent,
        DialogMultiOptionComponent,
        DialogDocumentsSigningComponent,
        DialogDeploymentNewsComponent,
        DialogTextInputComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        MatDividerModule,
        MatDialogModule,
        MatButtonModule,
        NzUploadModule,
        NzIconModule,
        NzTableModule,
        NzProgressModule,
        NzSpinModule,
        MatInputModule,
        QuillModule,
    ],
    exports: [
        DialogConfirmComponent,
        DialogUploadComponent,
        DialogFilesDisplayComponent,
        DialogAcceptanceComponent,
        DialogMultiOptionComponent,
        DialogDocumentsSigningComponent,
        DialogDeploymentNewsComponent,
        DialogTextInputComponent,
    ]
})
export class DialogsModule {
    // Dialogs Module should only be imported once in the application
    constructor(@Optional() @SkipSelf() parentModule: DialogsModule) {
        if (parentModule) {
            throw new Error('DialogsModule is already loaded. Import it in the CoreModule only');
        }
    }
}
